export const DEFAULT_THRESHOLD_BY_FIELD_NAME = {
  Logos: 80,
  Places: 30,
  Objects: 30,
  Emotions: 50,
  Activities: 30,
  Affinities: 30,
  Demographics: 50,
  'IAB Ad Product': 30,
  IAB: 30,
}
